import React, { useEffect, useState } from 'react';

import { Divider, Stack, Text, Title, Group, Loader } from '@mantine/core';
import useAthleteAttendance from 'hooks/reports/athletes/useAthleteAttendance';
import { useNavigate } from 'react-router-dom';
import { AthleteAttendanceReport } from 'types';

import { useDashboardStyles } from '../styles';

const AthleteAttendanceCard = (): JSX.Element => {
  const { classes: dashboard } = useDashboardStyles();
  const navigate = useNavigate();

  const [tableData, setTableData] = useState<AthleteAttendanceReport[]>([]);

  const { data, isLoading, isError, isSuccess } = useAthleteAttendance({ limit: '5' });

  const handleCardClick = (report: string): void => {
    navigate(`/reports/${report}`);
  };

  useEffect(() => {
    if (!isLoading && data) {
      setTableData(data.pages.map(page => page.data.results).flat());
    }
  }, [isLoading, data, setTableData]);

  return (
    <div
      className={`${dashboard.attendance} ${dashboard.card} ${dashboard.clickableCard}`}
      onClick={() => handleCardClick('athlete-attendance')}
    >
      <div className={dashboard.cardHeader}>
        <Title order={4}>Attendance Leaderboard</Title>
      </div>

      <Divider />

      {isLoading && (
        <Group position='center' py='xl'>
          <Loader size='lg' />
        </Group>
      )}

      {isError && (
        <Group position='center' py='xl'>
          <Text>Error</Text>
        </Group>
      )}

      {isSuccess && tableData.length > 0 && (
        <Stack p='md'>
          {tableData.map(athlete => (
            <Group position='apart' noWrap px='md' key={athlete.athleteId}>
              <Text fw='bold' color='dimmed'>
                {athlete.fullName}
              </Text>
              <Text fw='bold' color='dimmed'>
                {athlete.checkedInEvents} events
              </Text>
            </Group>
          ))}
        </Stack>
      )}

      {isSuccess && tableData.length === 0 && (
        <Group position='center' py='xl'>
          <Text>No data</Text>
        </Group>
      )}
    </div>
  );
};

export default AthleteAttendanceCard;
